<template>
    <div class="container">
        <div class="header">
            <van-image
                class="avatar"
                round
                width="1.04rem"
                height="1.04rem"
                :src="organInfo.logo"
            />
            <div class="organName">{{ organInfo.organName }}</div>
        </div>
        <div class="remind-text">
            <div>
                当前就诊人：
                <span>
                    {{ defaultCard ? defaultCard.name : "暂无就诊卡" }}
                </span>
            </div>
            <div>
                还可以绑卡数
                <span>{{ organInfo.available }}</span>
                张
            </div>
        </div>

        <div class="list">
            <div class="item" v-for="(item, index) in cardList" :key="index">
                <medical-card :card="item" />
            </div>
        </div>

        <div class="tools">
            <van-button
                round
                block
                size="small"
                type="primary"
                native-type="button"
                @click="addHandle"
            >
                添加就诊卡
            </van-button>
        </div>
    </div>
</template>

<script>
import medicalCard from '@/components/medical_card';
import medicalCardApi from '@/api/medicalCardApi';

export default {
    data() {
        return {
            organInfo: {},
            cardList: []
        }
    },
    methods: {
        addHandle() {
            const { $router, organId } = this;
            $router.push({
                path: '/medical_card/card_type_choose',
                query: {
                    organId
                }
            });
        }
    },
    created() {
        medicalCardApi.queryMedicalCardList(this.organId).then(res => {
            this.organInfo = { ...res.data };
            this.cardList = res.data.cardList;
        });
    },
    computed: {
        defaultCard() {
            return this.cardList.find((o) => {
                return o.isDefault;
            });
        }
    },
    props: {
        organId: {
            type: String,
            required: true
        }
    },
    components: {
        medicalCard
    }
}
</script>

<style lang="less" scoped>
.container {
    .header {
        height: 1.2rem;
        padding: 0.133333rem 0.32rem;
        background-color: @white-color;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        box-shadow: 0.08rem 0.08rem 0.106667rem rgba(26, 26, 26, 0.1);

        .organName {
            margin-left: 0.4rem;
            font-size: 0.426667rem;
        }
    }

    .remind-text {
        display: flex;
        justify-content: space-between;
        margin: 0 0.53rem;
        font-size: 0.36rem;
        line-height: 1rem;
        color: @grey-color;

        span {
            padding: 0 0.053333rem;
            color: @yellow-color;
        }
    }

    .list {
        position: fixed;
        top: 2.466667rem;
        bottom: 1.36rem;
        width: 100%;
        overflow-y: auto;

        .item:not(:first-child) {
            margin-top: 0.4rem;
        }

        .item:last-child {
            margin-bottom: 0.266667rem;
        }
    }

    .tools {
        position: fixed;
        bottom: 0;
        background-color: @white-color;
        padding: 0.213333rem 0.48rem;
        left: 0;
        right: 0;
        height: 0.933333rem;
        box-shadow: 0 -0.06rem 0.1rem 0.04rem rgba(0, 0, 0, 0.03);
        display: flex;
        align-items: center;
    }
}
</style>